import { Trans, useLingui } from "@lingui/react";
import { TradeOrgPages } from "src/types/tradeorgPages.ts";
import List from "./components/List.tsx";
import OrgLinks from "./components/OrgLinks.tsx";
import Title from "./components/Title.tsx";
import { Layout } from "./Layout.tsx";

const Nbf = () => {
  const { i18n } = useLingui();
  const pageName = TradeOrgPages.NBF;

  const pageTitle = i18n._({
    id: "tradeOrgLayout.page.title",
    message: "Advantages with {tradeOrgName}",
    comment: "Page title with trade organization name",
    values: { tradeOrgName: pageName.toUpperCase() },
  });

  const subTitle = i18n._({
    id: "tradeOrgLayout.nbf.subtitle.text",
    message: "The car is sold by a member of the Norwegian Automobile Industry Association",
    comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
  });

  const advantagesList = [
    i18n.t({
      id: "tradeOrgLayout.nbf.section.one.advantages.itemOne",
      message: "The car is technically checked and safety is ensured",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nbf.section.one.advantages.itemTwo",
      message: "The car has documented mileage and history",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nbf.section.one.advantages.itemThree",
      message: "You will receive a written purchase agreement with NBF's sales and delivery terms",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nbf.section.one.advantages.itemFour",
      message: "The car is free of financial encumbrances",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nbf.section.one.advantages.itemFive",
      message: "The Consumer Purchase Act applies and is followed for consumer purchases",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nbf.section.one.advantages.itemSix",
      message:
        "NBF sets quality requirements and provides business support to member companies to ensure compliance with laws and regulations",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
  ];

  const listTitle = i18n.t({
    id: "tradeOrgLayout.nbf.section.one.title",
    message: "Buying from a car dealer that is a member of the NBF means that:",
    comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
  });

  return (
    <Layout
      left={
        <>
          <Title title={pageTitle} subTitle={subTitle} />

          <div className="mt-40">
            <List title={listTitle} listElements={advantagesList} />

            <div className="mt-40 pb-40 border-b md:border-none">
              <h4 className="t4 mb-0">
                <Trans
                  id="tradeOrgLayout.nbf.section.two.title"
                  message="When you buy a car from an NBF member"
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </h4>

              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.nbf.section.two.text"
                  message="You buy safely when you buy a car from a dealer who is a member of NBF. NBF members have undertaken to follow NBF's ethical guidelines, which provide extra security."
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>

              <p className="mt-16 mb-0 text-m">
                <a href="/mobility/search/car?car_condition=2&warranty_insurance=1">
                  <Trans
                    id="tradeOrgLayout.nbf.section.two.link"
                    message="Look for cars with a condition report with warranty, and marked with NBF member when you search for a car."
                    comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                  />
                </a>
              </p>
            </div>
          </div>
        </>
      }
      right={<OrgLinks pageName={pageName} />}
    />
  );
};

export default Nbf;
